import PropTypes from "prop-types";

const VideoPropTypes = PropTypes.shape({
  id: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  communityLinksUrl: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  hasLinks: PropTypes.bool,
  displayTitle: PropTypes.string,
  hasDisplayTitle: PropTypes.bool,
  category: PropTypes.string,
  isUpcoming: PropTypes.bool,
  isOnAir: PropTypes.bool,
  scheduledStartTimeHumanized: PropTypes.string
});

export { VideoPropTypes }; //eslint-disable-line
